import React from "react";

import { Field, Inputs, useFieldValue } from "2g-form";

import { useServerMessage } from "b2b/i18n";
import useMessages from "./i18n/useMessages";

export function RezervaceVytvoreniDoplnkoveSluzby() {
  const { doplnkoveSluzbyLabel } = useMessages();
  const message = useServerMessage();
  const produkt = useFieldValue("produkt");

  return produkt?.doplnkoveSluzby?.length > 0 ? (
    <Field
      items={produkt.doplnkoveSluzby}
      label={doplnkoveSluzbyLabel()}
      component={Inputs.CheckboxArray}
      path="doplnkoveSluzby"
      content={({ data }) => (
        <span className="b2b-DopnkoveSluzbyRadioGroup">
          <div className="b2b-DopnkoveSluzbyRadioGroup-nazev">
            {message(data, "nazev")}
          </div>
          <div className="b2b-DopnkoveSluzbyRadioGroup-popis">
            {message(data, "popis")}
          </div>
        </span>
      )}
      light
    />
  ) : undefined;
}

RezervaceVytvoreniDoplnkoveSluzby.propTypes = {};

export default React.memo(RezervaceVytvoreniDoplnkoveSluzby);
